<template>
  <div class="login_container">
      <div>
        <section class="login_title">
            <h2>
                租戶登入
            </h2>
        </section>
        <section class="login_inputs">
            <div class="login_logo">
                <img src="@/assets/images/login/golden_logo.png" alt="高點國際開發有限公司">
            </div>
            <div class="login_account">
                <p for="account">戶號</p>
                <input v-model="form.account" type="text" id="account" placeholder="請輸入戶號">
            </div>
            <div class="login_password">
                <p for="password">密碼</p>
                <input v-model="form.password" type="password" id="password" placeholder="請輸入密碼">
            </div>
            <div class="login_verify">
                <a @click="refreshCode">
                    <span class="icon">
                        <img src="@/assets/images/login/icon_change.svg">
                    </span>
                </a>
                <SIdentify :identifyCode="identifyCode" />
              <div class="input-text">
                <input v-model="form.code" placeholder="請輸入驗證碼" type="text" required>
              </div>
            </div>
        </section>
        <section class="login_buttons">
            <button class="btn_style" @click="login_from">
                登入
            </button>
        </section>
      </div>
  </div>
</template>

<script>
import "@/assets/css/member/login.css";

import SIdentify from '@/components/login/SIdentify.vue'
export default {
    name: 'Login',
    data() {
        return {
            form: {
                account: '',
                password: '',
                code: ''
            },
            isSubmit: 0,
            identifyCodes: '1234567890', //想隨機產生的
            identifyCode: '', //產生的字
        };
    },
    components: {
        SIdentify
    },
    filters: {},
    beforeMount: function () {
        this.refreshCode();
    },
    methods: {
        // 刷新驗證碼
        refreshCode() {
            this.identifyCode = '';
            this.makeCode(this.identifyCodes, 4);
        },
        // 隨機產驗證碼
        randomNum (min, max) {
            max = max + 1;
            return Math.floor(Math.random() * (max - min) + min);
        },
        // 隨機產生數
        makeCode (data, len) {
            for (let i = 0; i < len; i++) {
                this.identifyCode += data[this.randomNum(0, data.length - 1)];
            }
        },
        login_axios () {
            const loginData = new FormData();
            loginData.append('CMD' , 'FrontLogin');
            loginData.append('username' , this.form.account.toUpperCase());
            loginData.append('password' , this.form.password);
            this.$axios.post(process.env.VUE_APP_FROENT_API_PREFIX, loginData)
            .then(response => {
                console.log(response);
                if (response.data.loginTrue) {
                    // this.$cookies.set('house_number', this.form.account);
                    this.$store.state.house_number = this.form.account.toUpperCase();
                    localStorage.house_number = this.form.account.toUpperCase();
                    localStorage.setItem('DiagnosticTest', response.data.loginTrue.verifyNumber);
                    this.$router.push({ name: 'MemberHome' });
                } else {
                    alert(response.data.msg);
                    this.form.code = '';
                    this.refreshCode();
                }
            })
            .catch(error => {
                console.log(error);
            })
        },
        login_from () {
            if (this.form.code == this.identifyCode) {
                this.login_axios();
            } else {
                alert('驗證碼錯誤');
                this.refreshCode();
            }
        }
    },
    mounted: function () {},
};
</script>

<style>

</style>
